// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__H7e0a","link":"Footer_link__FaSPg","divider":"Footer_divider__-p04h"};